<template>
  <v-dialog v-model="active" width="650px">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="on" />
    </template>
    <v-card>
      <v-card-title>GTAs</v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <v-container fluid class="pa-0">
          <v-row class="ma-0">
            <v-simple-table class="full-width">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Data da GTA</th>
                    <th class="text-left">Data da Saída</th>
                    <th class="text-left">Número da GTA</th>
                    <th class="text-left">Série</th>
                    <th class="text-left">Quantidade de animais</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in gtaListSorted"
                    :key="item['ds_serie_gta']"
                  >
                    <td>{{ item["dt_gta"] | formatDate }}</td>
                    <td>{{ item["dt_saida"] | formatDate }}</td>
                    <td>{{ item["nr_gta"] }}</td>
                    <td>
                      {{ item["ds_serie_gta"] }}
                    </td>
                    <td>{{ item["qt_animais"] }}</td>
                  </tr>
                  <tr>
                    <td colspan="4" class="font-weight-bold">Total</td>
                    <td class="font-weight-bold">{{qtSaidas}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="active = false"> Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as moment from "moment";

export default {
  name: "GtaListDialog",
  data: () => ({
    active: false,
  }),
  props: {
    gtaList: {
      type: Array,
      required: true
    },
    qtSaidas: Number
  },
  filters: {
    formatDate(value) {
      const parsedDate = moment(value, "YYYY-MM-DD");
      if (!parsedDate.isValid()) return "";
      return parsedDate.format("DD/MM/YYYY");
    },
  },
  computed: {
    gtaListSorted() {
      return this.gtaList.sort((a, b) => new Date(a["dt_gta"]) - new Date(b["dt_gta"]))
    }
  }
};
</script>

<style scoped></style>
